

module.exports = (element, amount) => {
    let aditionalAmount = amount || 0;
    if (typeof(amount) === 'undefined') {
        aditionalAmount = $('header').length ? ($('header').height() + 20) : aditionalAmount;
    }
    const position = element && element.length ? element.offset().top - aditionalAmount : 0;

    $('html, body').animate({
        scrollTop: position,
    }, 500);
    if (!element) {
        $('.logo-home').focus();
    }
};
